import { Injectable }    from '@angular/core';
import { HttpClient, HttpHeaders  } from '@angular/common/http';
import { Observable } from 'rxjs';

import 'rxjs/add/operator/toPromise';

import * as ent from '../entities/index'
import * as filters from '../filters/index'
import * as serv from '../services/index'


@Injectable()
export class ExportService {

    //#region URLs
    private baseExportUrl = "/Export";  // URL to web api
    private getEquipmentTemplateRulesURL = '';
    private getExportFieldsURL = '';
    private getExportFilesURL = '';
    private getFieldTypesURL = '';
    private getFileFieldsURL = '';
    private getFileTypesURL = '';
    private getFileFormatsURL = '';
    private getRequestTypeFilesURL = '';
    private getRequestExportPropertyValuesURL = '';
    private getRequestExportFileDataURL = '';

    private saveExportFieldURL = '';
    private saveFileFieldURL = '';
    private saveEquipmentTemplateRuleURL = '';
    //#endregion

  
    appConfig: ent.AppConfig;

    constructor(private httpClient: HttpClient, private configService: serv.ConfigService) {
        this.baseExportUrl = this.configService.appConfig.UrlBase + this.baseExportUrl;

        //#region initialize URLs
        this.getEquipmentTemplateRulesURL = this.baseExportUrl + '/GetEquipmentTemplateRules';
        this.getExportFieldsURL = this.baseExportUrl + '/GetExportFields';
        this.getExportFilesURL = this.baseExportUrl + '/GetExportFiles';
        this.getFieldTypesURL = this.baseExportUrl + '/GetFieldTypes';
        this.getFileFieldsURL = this.baseExportUrl + '/GetFileFields';
        this.getFileTypesURL = this.baseExportUrl + '/GetFileTypes';
        this.getFileFormatsURL = this.baseExportUrl + '/GetFileFormats';
        this.getRequestTypeFilesURL = this.baseExportUrl + '/GetRequestTypeFiles';
        this.getRequestExportPropertyValuesURL = this.baseExportUrl + '/GetRequestExportPropertyValues';
        this.getRequestExportFileDataURL = this.baseExportUrl + '/GetExportFileData';
        

        this.saveExportFieldURL = this.baseExportUrl + '/SaveExportField';
        this.saveFileFieldURL = this.baseExportUrl + '/SaveFileField';
        this.saveEquipmentTemplateRuleURL = this.baseExportUrl + '/SaveEquipmentTemplateRule';
        //#endregion
           
    }

    //#region Get Methods
    getEquipmentTemplateRules(): Observable<ent.EquipmentTemplateRule[]> {
        return this.httpClient.get<ent.EquipmentTemplateRule[]>(this.getEquipmentTemplateRulesURL);
    }

    getExportFields(): Observable<ent.ExportField[]> {
        return this.httpClient.get<ent.ExportField[]>(this.getExportFieldsURL);
    }

    getExportFiles(): Observable<ent.ExportFile[]> {
        return this.httpClient.get<ent.ExportFile[]>(this.getExportFilesURL);
    }

    getFieldTypes(): Observable<ent.FieldType[]> {
        return this.httpClient.get<ent.FieldType[]>(this.getFieldTypesURL);
    }

    getFileFields(): Observable<ent.FileField[]> {
        return this.httpClient.get<ent.FileField[]>(this.getFileFieldsURL);
    }

    getFileTypes(): Observable<ent.FileType[]> {
        return this.httpClient.get<ent.FileType[]>(this.getFileTypesURL);
    }
    
    getFileFormats(): Observable<ent.FileFormat[]> {
        return this.httpClient.get<ent.FileFormat[]>(this.getFileFormatsURL);
    }

    getRequestTypeFiles(): Observable<ent.RequestTypeFile[]> {
        return this.httpClient.get<ent.RequestTypeFile[]>(this.getRequestTypeFilesURL);
    }

    getRequestExportPropertyValues(requestIDs: number[]): Observable<ent.ExportField[]> {
        return this.httpClient.post<ent.ExportField[]>(this.getRequestExportPropertyValuesURL, requestIDs);
    }

    getRequestGetExportFileData(requestIDs: number[]): Observable<ent.ExportFileData> {
        return this.httpClient.post<ent.ExportFileData>(this.getRequestExportFileDataURL, requestIDs);
    }
    //#endregion

    //#region Save Methods
    saveExportField(record: ent.SaveExportFieldRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.saveExportFieldURL, record);
    }

    saveFileField(record: ent.SaveFileFieldRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.saveFileFieldURL, record);
    }

    saveEquipmentTemplateRule(record: ent.SaveEquipmentTemplateRuleRequest): Observable<ent.Response> {
        return this.httpClient.post<ent.Response>(this.saveEquipmentTemplateRuleURL, record);
    }
    //#endregion
}

